const DEFAULT_TITLE = 'Афиша мероприятий';

export default (to, from, next) => {
  if (!(to?.matched || []).length) { // @redirect empty page
    /** Как бы костыль,
     * Редирект с /event/dashboard/ на /event/view/,
     * для неорганизаторов, потому что наши организаторы
     * скидывают детям ссылку на редактор, а не на лендинг
     * >:[
     */
    const eventEditorRegExp = /event\/dashboard\/(\d+)/;
    const matchedRoute = (to.fullPath || '').match(eventEditorRegExp);
    const [_, eventId] = matchedRoute || [];

    const path = eventId ? `/event/view/${eventId}` : '/404';
    window.location.href = path;
  }
  if (to.meta.title) {
    document.title = `${to.meta.title} - ${DEFAULT_TITLE}`;
  } else {
    document.title = DEFAULT_TITLE;
  }

  return next();
};
